import {Component, OnInit, ViewChild} from '@angular/core';
import {Activity, ChildrenAffirmation, ReportAffirmation, StudentClass} from '../../../models/applicationFeature';
import {StudentClassService} from '../../../services/student-class.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {AffirmationService} from '../../../services/affirmation.service';
import {ActivatedRoute} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import * as moment from 'moment';
import {AffirmationClass} from '../../../models/AffirmationClass';
import {MatDialog} from '@angular/material/dialog';
import {SearchDialogComponent} from '../../shared/search-dialog/search-dialog.component';

@Component({
    selector: 'app-affirmation-report-details',
    templateUrl: './affirmation-report-details.component.html',
    styleUrls: ['./affirmation-report-details.component.scss']
})
export class AffirmationReportDetailsComponent implements OnInit {
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    currentQuery = '';
    isLoading: boolean;
    activities: Activity[];
    studentClasses: StudentClass[];
    childrenEnrollments: ChildrenAffirmation[];
    reportAffirmations: ReportAffirmation[];
    singleReportAffirmation: ReportAffirmation;
    affirmationId: number;
    pageTitle: string;
    chartResults: any;
    simpleSearchSelectedValue: any;
    affirmationSearchFields: any;
    searchValue: any;
    displayEnrollments: MatTableDataSource<ChildrenAffirmation> = new MatTableDataSource<ChildrenAffirmation>();
    resultLength: any;
    isSearchLoading: boolean;
    currentActivity: Activity;
    reports: any[] = [];
    currentForm: any;
    columnsWithLevel = ['childDisplayName', 'className', 'level_description', 'fatherDisplayName', 'motherDisplayName', 'enroll_date'];
    columnsNoLevel = ['childDisplayName', 'className', 'fatherDisplayName', 'motherDisplayName', 'enroll_date'];
    displayedColumns = this.columnsWithLevel;

    constructor(private route: ActivatedRoute,
                public dialog: MatDialog,
                private commonService: CommonService,
                private studentClassService: StudentClassService,
                public toastMessagesService: ToastMessagesService,
                private affirmationService: AffirmationService) {
        this.isLoading = false;
        this.pageTitle = 'Λεπτομέρειες δήλωσης';
        this.affirmationSearchFields = new AffirmationClass().getSearchFields();
        this.isLoading = false;
    }

    async ngOnInit() {
        this.route.queryParams.subscribe(async (params) => {
            this.affirmationId = params.id;
            this.isLoading = true;
            this.studentClasses = await this.studentClassService.initClasses();
            await this.initReports();
            await this.initForm();
            const completed = this.calculate(1);
            // this.childrenEnrollments = await this.affirmationService.initChildrenAffirmations();
            // this.reportAffirmations = await this.affirmationService.initReportAffirmations(this.studentClasses, this.childrenEnrollments);
            // this.getCurrentAffirmation();
            await this.initActivities();
            // this.setupChildrenEnrollments();
            this.chartResults = [ this.calculate(1), this.calculate(0), this.calculate(-1)];

            this.isLoading = false;
            console.log(this.currentForm);
        });
    }

    async initForm() {
        try {
            const formRequest = await this.commonService.getList(`forms/form?uniqueId=${this.affirmationId}`);
            this.currentForm = formRequest.object[0];
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }
    async initReports() {
        try {
            const reportQuery = await this.commonService.getList(`reports/affirmation/children?uniqueId=${this.affirmationId}`);
            this.reports = reportQuery.object;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initActivities() {
        try {
            const activitiesRequest = await this.commonService.getList('activities');
            for (const activity of activitiesRequest.object) {
                const levelsRequest = await this.commonService.getList(`activities/assign?id=${activity.id}`);
                activity.assignedLevels = levelsRequest.object;
            }
            this.activities = activitiesRequest.object;
            this.currentActivity = this.activities.find(activity => activity.id === this.reports[0].activity_id);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    setupChildrenEnrollments() {
        const enrollments = this.childrenEnrollments.filter(en => en.activity_id === this.currentActivity.id);
        for (const enrollment of enrollments) {
            enrollment.childDisplayName = `${enrollment.child_first_name} ${enrollment.child_last_name}`;
        }

        this.displayEnrollments = new MatTableDataSource<ChildrenAffirmation>(enrollments);
        this.displayEnrollments.paginator = this.paginator;
        this.displayEnrollments.sort = this.sort;
        this.resultLength = enrollments.length;
    }

    getCurrentAffirmation() {
       this.singleReportAffirmation = this.reportAffirmations.find(reportAffirmation =>
           reportAffirmation.affirmation.id === this.affirmationId);
    }

    getChartMax(dataArray): number {
      // return this.singleReportAffirmation.notAnswered + this.singleReportAffirmation.completed;
        return this.reports.length;
    }

    criteriaChanged() {
        this.searchValue = '';
    }

    async fastSearch($event: KeyboardEvent) {
        if ($event.keyCode === 13) {
            await this.search();
        }
    }

    async search() {
        if (!this.simpleSearchSelectedValue) {
            this.toastMessagesService.toastMessages('Παρακαλούμε συμπληρώστε κριτήριο αναζήτησης');
            return false;
        }
        this.isSearchLoading = true;
        this.displayEnrollments.data = [];
        if (this.searchValue) {
            let filter  = '';
            if (this.simpleSearchSelectedValue.type === 'text') {
                filter = `where ${this.simpleSearchSelectedValue.field} LIKE '%${this.searchValue}%'`;
            }

            if (this.simpleSearchSelectedValue.type === 'date') {
                const dateValue = moment(this.searchValue).format('YYYY-MM-DD');
                console.log(dateValue);
                filter = `where convert(varchar(10), ${this.simpleSearchSelectedValue.field}, 120)= '${dateValue}'`;
            }
            this.currentQuery = filter;
            try {
                const resultObject = await this.commonService.
                getList(`affirmations/children/activity?id=${this.singleReportAffirmation.affirmation.activityId}&filter=${filter}`);
                const enrollments = resultObject.object as ChildrenAffirmation[];
                for (const enrollment of enrollments) {
                    enrollment.childDisplayName = `${enrollment.child_first_name} ${enrollment.child_last_name}`;
                }
                this.displayEnrollments.data = enrollments;
                this.resultLength = enrollments.length;
            } catch (e) {
                this.toastMessagesService.toastErrorMessage(e.message);
            } finally {
                this.isSearchLoading = false;
            }
        } else {
            this.currentQuery = '';
            try {
                const resultObject = await this.commonService.
                getList(`affirmations/children/activity?id=${this.singleReportAffirmation.affirmation.activityId}`);
                const enrollments = resultObject.object as ChildrenAffirmation[];
                for (const enrollment of enrollments) {
                    enrollment.childDisplayName = `${enrollment.child_first_name} ${enrollment.child_last_name}`;
                }
                this.displayEnrollments.data = enrollments;
                this.resultLength = enrollments.length;
            } catch (e) {
                this.toastMessagesService.toastErrorMessage(e.message);
            } finally {
                this.isSearchLoading = false;
            }
        }
    }

    calculate(status) {
        const totalSent = this.reports.length;
        const completed = this.reports.filter(form => form.status_id === status).length;
        return completed;
    }

    showSearchDialog() {
        const searchQuery = this.dialog.open(SearchDialogComponent, {
            width: '1200px',
            height: '670px',
            data: {
                searchFields: this.affirmationSearchFields,
                section: 'collegeAffirmations',
            }
        });

        searchQuery.afterClosed().subscribe(async (query: string) => {
            this.displayEnrollments.data = [];
            this.isSearchLoading = true;
            if (query) {
                this.currentQuery = query;
                try {
                    const resultObject = await this.commonService.
                    getList(`affirmations/children/activity?id=${this.singleReportAffirmation.affirmation.activityId}&filter=${query}`);
                    const enrollments = resultObject.object as ChildrenAffirmation[];
                    for (const enrollment of enrollments) {
                        enrollment.childDisplayName = `${enrollment.child_first_name} ${enrollment.child_last_name}`;
                    }
                    this.displayEnrollments.data = enrollments;
                    this.resultLength = enrollments.length;
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                } finally {
                    this.isSearchLoading = false;
                }
            } else {
                this.currentQuery = '';
                try {
                    const resultObject = await this.commonService.
                    getList(`affirmations/children/activity?id=${this.singleReportAffirmation.affirmation.activityId}`);
                    const enrollments = resultObject.object as ChildrenAffirmation[];
                    for (const enrollment of enrollments) {
                        enrollment.childDisplayName = `${enrollment.child_first_name} ${enrollment.child_last_name}`;
                    }
                    this.displayEnrollments.data = enrollments;
                    this.resultLength = enrollments.length;
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                } finally {
                    this.isSearchLoading = false;
                }
            }
        });
    }

    getReports(status: number) {
        return this.reports.filter(report => report.status_id === status);
    }
}
